<template>
  <div v-wechat-title="this.title">
    <!-- <keep-alive :include="keepAliveList"> -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <ShowDetailTabbar :slug="slug" />
  </div>
</template>

<script>
  import ShowDetailTabbar from './show-detail-tabbar.vue'
  export default {
    name: "Show",
    components: {
      ShowDetailTabbar
    },
    data () {
      return {
        title: '',
        active: 0,
        slug: '',
        keepAliveList: [
          'ShowDetail',
          'PublicEpisodes',
          'PremiumEpisodes',
          'HotCommentsList']
      }
    },
    watch: {
      'slug' (newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.$api.show.detail(newVal).then(res => {
            this.title = res.data.title
          })
        }
      }
      // '$route' (to, from) {
      //   window.console.log("监听到路由变化")
      //   window.console.log(this.$route.name)
      //   if (this.$route.name == 'UserCenter') {
      //     window.console.log("准备跳转到UserCenter")
      //     this.activeIndex = 4
      //   }
      //   window.console.log(to)
      //   window.console.log(from)
      // }
    },
    mounted () {
      this.slug = this.$route.params.slug
    }
  }
</script>

<style lang="css" scoped>
</style>
